@if ($imgSrc | async; as src) {
  <img [lazyLoad]="src" [defaultImage]="defaultImg" [alt]="imgAlt" />
}
